import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { useAuth } from '@/app/AuthContext.jsx';
import { useReceptorInbox } from '@/hooks';
import { DESKTOP_QUERY, useMediaQuery } from '@/hooks/useMediaQuery';
import { extractList } from '@/lib/apiList';
import { MailIcon, PersonOutlineOutlinedIcon } from '@/ui/icons';
import './ReceptorLayout.css';

// Home and Tasks have no view yet: hidden until they exist.
const NAV = [
  { label: 'Solicitudes', Icon: MailIcon, to: '/solicitudes', counts: true },
  { label: 'Perfil', Icon: PersonOutlineOutlinedIcon, to: '/perfil' },
];

export function ReceptorNavView({ pendingCount, name, onLogout }) {
  return (
    <nav className="rx-nav" aria-label="Receptor">
      <span className="rx-nav__brand" aria-hidden="true">
        RECEP<strong>THOR</strong>
      </span>
      {NAV.map(({ label, Icon, to, counts }) => (
        <NavLink
          key={label}
          to={to}
          className={({ isActive }) =>
            `rx-nav__item${isActive ? ' rx-nav__item--current' : ''}`
          }
        >
          <Icon size={22} />
          {label}
          {counts && pendingCount > 0 ? (
            <span
              className="rx-nav__count"
              aria-label={`${pendingCount} ${pendingCount === 1 ? 'pendiente' : 'pendientes'}`}
            >
              {pendingCount}
            </span>
          ) : null}
        </NavLink>
      ))}
      {onLogout ? (
        <div className="rx-nav__foot">
          {name ? <p className="rx-nav__user">{name}</p> : null}
          <button type="button" className="rx-nav__logout" onClick={onLogout}>
            Cerrar sesión
          </button>
        </div>
      ) : null}
    </nav>
  );
}

ReceptorNavView.propTypes = {
  pendingCount: PropTypes.number,
  name: PropTypes.string,
  onLogout: PropTypes.func,
};

function displayName(user) {
  const name = `${user?.firstName ?? ''} ${user?.lastName ?? ''}`.trim();
  return name || user?.email || '';
}

// The rail (desktop) carries what the page used to: how many requests wait for
// a quote and the way out. On a phone the tab bar stays as it was, so neither
// the count nor the logout is read there (Perfil keeps its own button).
function LiveReceptorNav() {
  const desktop = useMediaQuery(DESKTOP_QUERY);
  const { user, logout, organizationId } = useAuth() ?? {};
  const inbox = useReceptorInbox(organizationId, {
    enabled: desktop && organizationId != null,
  });
  return (
    <ReceptorNavView
      pendingCount={desktop ? extractList(inbox.data).length : 0}
      name={displayName(user)}
      onLogout={desktop && logout ? () => logout() : undefined}
    />
  );
}

// The preview routes run without the API: no counter, no session.
export default function ReceptorNav({ preview = false }) {
  return preview ? <ReceptorNavView /> : <LiveReceptorNav />;
}

ReceptorNav.propTypes = {
  preview: PropTypes.bool,
};
